import { Button, message, Tooltip, Popover } from 'antd';
import { MonitorPlay, Lock, Copy, Check } from 'lucide-react';
import React, { useState } from 'react';
import useLongPress from '../../hooks/useLongPress';
import PassCodeModal from '../popups/PassCodeModal';

function ScreenIconView({ isLocked, name, screencode, screensStatus, onScreenClicked, onRemoteAction, record, iconOnly = false, nameOnly = false }) {
    // const [isLocked, setIsLocked] = useState(false);
    const [open, setOpen] = useState(false);
    const [isPassCodeOpen, setIsPassCodeOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    const [iconPopoverOpen, setIconPopoverOpen] = useState(false);


    const hide = () => {
        setOpen(false);
    };

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    const onLongPress = () => {
        copyToClipboard(screencode);
        message.success("Screencode copied to clipboard")
    };

    const lockScreen = (code) => {

        console.log("lockscreen")

        // setIsLocked(true);
        setOpen(false);
        onRemoteAction("lock", screensStatus[record.ScreenCode], record, { code: code });
    };


    const unlockScreen = (code) => {
        // setIsLocked(false);
        onRemoteAction("unlock", screensStatus[record.ScreenCode], record, { code: code });
        // setOpen(false);
    };

    const onClick = (e) => {

    }

    const onIconClick = (e) => {
        console.log('onIconClick is triggered ' + e)


        if (e.detail == 3) {
            console.log("screensStatus " + JSON.stringify(screensStatus))
            console.log("screencode " + record.ScreenCode)
            console.log("JSON " + JSON.stringify(screensStatus[record.ScreenCode]))

            if (screensStatus[record.ScreenCode]) {

                if ("lock" in screensStatus[record.ScreenCode] && screensStatus[record.ScreenCode].lock !== 0) {

                    // unlockScreen(screensStatus[record.ScreenCode].lock);
                    setIsPassCodeOpen(true);
                }
                else {
                    setIsPassCodeOpen(true);
                }
            }
        }
        e.preventDefault();
    }
    const defaultOptions = {
        shouldPreventDefault: true,
        delay: 500,
    };

    const copyToClipboard = str => {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected =
            document.getSelection().rangeCount > 0
                ? document.getSelection().getRangeAt(0)
                : false;
        el.select();
        const success = document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selected);
        }
        return success;
    };

    const longPressEvent = useLongPress(onLongPress, onClick, defaultOptions);
    const validPass = screensStatus[record.ScreenCode] ? (("lock" in screensStatus[record.ScreenCode]) ? screensStatus[record.ScreenCode].lock : null) : null

    const screencodePopoverContent = (
        <div style={{ minWidth: 220 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <div style={{
                    width: 32, height: 32, borderRadius: 8, flexShrink: 0,
                    background: isLocked ? 'linear-gradient(135deg,#fef2f2,#fecaca)' : 'linear-gradient(135deg,#eef2ff,#e0e7ff)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    <MonitorPlay size={16} color={isLocked ? '#ef4444' : '#6366f1'} />
                </div>
                <div>
                    <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 500, lineHeight: 1.2 }}>Screen Code</div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: '#0f172a', lineHeight: 1.4 }}>{name}</div>
                </div>
            </div>
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                gap: 8, padding: '8px 10px', borderRadius: 10,
                background: '#f8fafc', border: '1px solid #e2e8f0',
            }}>
                <span style={{ fontFamily: 'monospace', fontSize: 11, color: '#475569', letterSpacing: '0.02em', wordBreak: 'break-all' }}>
                    {screencode}
                </span>
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        copyToClipboard(screencode);
                        setCopied(true);
                        message.success('Screen code copied!');
                        setTimeout(() => setCopied(false), 2000);
                    }}
                    style={{
                        flexShrink: 0, background: copied ? '#ecfdf5' : '#eef2ff',
                        border: `1px solid ${copied ? '#86efac' : '#c7d2fe'}`,
                        borderRadius: 6, padding: '4px 6px', cursor: 'pointer',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        transition: 'all 0.2s',
                    }}
                >
                    {copied ? <Check size={13} color="#16a34a" /> : <Copy size={13} color="#6366f1" />}
                </button>
            </div>
        </div>
    );

    const renderIcon = (
        <Popover
            content={screencodePopoverContent}
            trigger="hover"
            placement="top"
            open={iconPopoverOpen}
            onOpenChange={setIconPopoverOpen}
            overlayInnerStyle={{ padding: 14, borderRadius: 14, boxShadow: '0 8px 32px rgba(99,102,241,0.12)' }}
            overlayStyle={{ zIndex: 2000 }}
        >
            <div
                {...longPressEvent}
                onClick={e => { e.stopPropagation(); onIconClick(e); }}
                style={{ position: "relative", flexShrink: 0, cursor: "pointer" }}
            >
                <div style={{
                    width: 48,
                    height: 48,
                    borderRadius: 14,
                    background: isLocked ? "linear-gradient(135deg, #fef2f2, #fee2e2)" : "linear-gradient(135deg, #eef2ff, #e0e7ff)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "background 0.2s",
                }}>
                    <MonitorPlay size={24} color={isLocked ? "#ef4444" : "#6366f1"} />
                </div>
                {isLocked && (
                    <div style={{
                        position: "absolute",
                        bottom: -3,
                        right: -3,
                        width: 16,
                        height: 16,
                        borderRadius: "50%",
                        background: "#ef4444",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px solid #fff",
                    }}>
                        <Lock size={8} color="#fff" />
                    </div>
                )}
            </div>
        </Popover>
    );

    const renderName = (
        <button
            onClick={() => onScreenClicked(record)}
            style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
                fontFamily: "var(--font-sans)",
                fontSize: 14,
                fontWeight: 600,
                color: "#0f172a",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: 300,
                transition: "color 0.15s",
            }}
            onMouseEnter={e => e.currentTarget.style.color = "#6366f1"}
            onMouseLeave={e => e.currentTarget.style.color = "#0f172a"}
        >
            {name}
        </button>
    );

    // iconOnly / nameOnly modes for split-column layout
    if (iconOnly) {
        return (
            <div>
                <PassCodeModal validPass={validPass} mode={isLocked ? "unlock" : "lock"} open={isPassCodeOpen} needClose={() => setIsPassCodeOpen(false)}
                    onComplete={(code, mode) => { setIsPassCodeOpen(false); if (mode === "lock") lockScreen(code); }}
                    onPasscodeValid={() => unlockScreen()}
                    onPasscodeFail={() => message.error("The passcode is incorrect. Please contact system admin for further assistance")}
                />
                {renderIcon}
            </div>
        );
    }

    if (nameOnly) {
        return renderName;
    }

    return (
        <div >
            <PassCodeModal validPass={validPass} mode={isLocked ? "unlock" : "lock"} open={isPassCodeOpen} needClose={() => {
                setIsPassCodeOpen(false);
            }} onComplete={(code, mode) => {
                setIsPassCodeOpen(false);
                if (mode === "lock")
                    lockScreen(code)
            }}
                onPasscodeValid={() => {
                    unlockScreen()
                }}
                onPasscodeFail={() => {
                    message.error("The passcode is incorrect. Please contact system admin for further assistance")
                }}
            >
            </PassCodeModal>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                {renderIcon}
                {renderName}
            </div>
        </div >
    );
}

export default ScreenIconView;